import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import usePapaBonus from '../usePapaBonus';
import { toggleAuthPopup } from '../../../state/modules/ui/actions';
import { isDiscountCashbackSystemSelector } from '../../../state/modules/city/selectors';
import papa_Bonus_img from '../assets/Papa_Bonus.jpg';
// Components
import Container from '../../../components/Container';
import Heading from '../../../components/Heading';
import GiftsSlider from '../../../components/GiftsSlider/DesktopView';
import Accordion from '../partials/Accordion';

// Assets
import Pizza from '../../../icons/papabonus/greenPizza.svg';
import Check from '../../../icons/papabonus/greenCheck.svg';
import Cash from '../../../icons/papabonus/greenCash.svg';
import LollipopIconSmall from '../../../icons/LollipopIconSmall.svg';

// Router
import { getRoute } from '../../../entry/routes';

// Config
// Style
import styles from './PapaBonus.styl';
import { Link } from 'react-router-dom';
import Button from '../../../components/Button';
import { showPopup } from '../../../state/modules/popup';

const cx = classNames.bind(styles);

export default function PapaBonusPage() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const avatar = useSelector(state => state.user.profile.avatar);
  const loyalty = useSelector(state => state.user.profile.loyalty);
  const isAuthenticated = useSelector(state => state.user.isAuthenticated);
  const isDiscountCashbackSystem = useSelector(isDiscountCashbackSystemSelector);
  const sailplayType = useSelector(state => state.city?.userCity?.sailplay?.type);
  const userCity = useSelector(state => state.city?.userCity);
  const isOldLoyalty = useMemo(() => sailplayType === 'gifts', [sailplayType]);
  const isRadomCity = useMemo(() => {
    const supertag = userCity?._supertag?.toLowerCase();
    const cityName = userCity?.name?.toLowerCase();
    return supertag === 'radom' || cityName === 'radom';
  }, [userCity]);
  const { articles, cashbackNumber, isGiftsOpen, cashbackPercent } = usePapaBonus();
  const onLinkClick = () => {
    dispatch(toggleAuthPopup(true));
  };
  const showSignIn = () => {
    return dispatch(showPopup('auth', { step: 'signIn' }));
  };
  return (
    <div className={cx('PapaBonus')}>
      <div className={cx('PapaBonus__white', { PapaBonus__white_borders: isGiftsOpen })}>
        <Container className={cx('PapaBonus__container')}>
          <Heading className={cx('PapaBonus__title_1')} level={2}>
            {intl.formatMessage({
              id: isRadomCity ? 'papabonus.radom.header.title2' : 'papabonus.header.title2',
            })}
          </Heading>
          <div className={cx('PapaBonus__title_4')}>
            {intl.formatMessage({
              id: isRadomCity ? 'papabonus.radom.header1.subtitle3' : 'papabonus.header1.subtitle3',
            })}
          </div>
          <div className={cx('PapaBonus__main')}>
            <div className={cx('PapaBonus__left')}>
              <div className={cx('PapaBonus__subtitle')}>
                <div className={cx('PapaBonus__subtitle_container1')}>
                  <span className={cx('PapaBonus__subtitle_greenTitle')}>
                    {intl.formatMessage({
                      id: `papabonus.header.title3`,
                    })}
                  </span>
                  <span>{intl.formatMessage({ id: `papabonus.header1.subtitle2ru` })}</span>
                </div>
                <div className={cx('PapaBonus__subtitle_container2')}>
                  <div>
                    <div className={cx('PapaBonus__subtitle_greenTitle')}>
                      {intl.formatMessage({ id: `papabonus.header1.subtitle4ru` })}
                    </div>
                    <div className={cx('PapaBonus__subtitle_greenTitle')}>
                      {intl.formatMessage({ id: `papabonus.header1.subtitle6ru` })}
                    </div>
                    <div>{intl.formatMessage({ id: `papabonus.header1.subtitle5ru` })}</div>
                  </div>
                  {/*<span className={cx('PapaBonus__subtitle_greenTitle')}>*/}
                  {/*  {intl.formatMessage({*/}
                  {/*    id: `papabonus.header.title4`,*/}
                  {/*  })}*/}
                  {/*</span>*/}
                  {/*<div className={cx('PapaBonus__subtitle_greenTitle')}>*/}
                  {/*  {intl.formatMessage({*/}
                  {/*    id: `papabonus.header.title5`,*/}
                  {/*  })}*/}
                  {/*</div>*/}
                  {/*<div>{intl.formatMessage({ id: `papabonus.header1.subtitle3ru` })}</div>*/}
                </div>
              </div>
              <div className={cx('PapaBonus__wrapper')}>
                <Accordion title={intl.formatMessage({ id: 'papabonus.question1' })}>
                  <div className={cx('PapaBonus__workContainer')}>
                    <div className={cx('PapaBonus__itemContainer')}>
                      <Pizza width={22} height={22} />
                      <div className={cx('PapaBonus__greenText')}>
                        {intl.formatMessage({
                          id: `papabonus.signin`,
                        })}
                      </div>
                    </div>
                    <div className={cx('PapaBonus__itemText')}>
                      {intl.formatMessage({
                        id: `papabonus.workText`,
                      })}
                    </div>
                    <div className={cx('PapaBonus__itemContainer')}>
                      <Check width={22} height={22} />
                      <div className={cx('PapaBonus__greenText')}>
                        {intl.formatMessage({
                          id: `papabonus.follow`,
                        })}
                      </div>
                    </div>
                    <div className={cx('PapaBonus__itemText')}>
                      {intl.formatMessage({
                        id: `papabonus.checkText`,
                      })}
                    </div>
                    <div className={cx('PapaBonus__itemContainer')}>
                      <Cash width={22} height={22} />
                      <div className={cx('PapaBonus__greenText')}>
                        {intl.formatMessage({
                          id: `papabonus.sendBonuses`,
                        })}
                      </div>
                    </div>
                    <div className={cx('PapaBonus__itemText')}>
                      {intl.formatMessage({
                        id: `papabonus.cashText`,
                      })}
                    </div>
                  </div>
                </Accordion>
                <Accordion title={intl.formatMessage({ id: 'papabonus.question2' })}>
                  <div className={cx('PapaBonus__workContainer')}>
                    <div className={cx('PapaBonus__itemContainer')}>
                      <div className={cx('PapaBonus__greenText2')}>
                        {intl.formatMessage({
                          id: `papabonus.highCashback`,
                        })}
                      </div>
                    </div>
                    <div className={cx('PapaBonus__itemText2')}>
                      {intl.formatMessage({
                        id: `papabonus.highCashbackText`,
                      })}
                    </div>
                    <div
                      className={cx(
                        'PapaBonus__loyaltyButton',
                        'PapaBonus__loyaltyButton_gradient',
                      )}
                    >
                      <div className={cx('PapaBonus__lollipop')}>
                        <LollipopIconSmall width={29} height={29} />
                      </div>
                      {intl.formatMessage({ id: 'profile.cashback.label' }, { value: 50 })}
                    </div>

                    <div className={cx('PapaBonus__itemContainer')}>
                      <div className={cx('PapaBonus__greenText2')}>
                        {intl.formatMessage({
                          id: `papabonus.baseCashback`,
                        })}
                      </div>
                    </div>
                    <div className={cx('PapaBonus__itemText2')}>
                      {intl.formatMessage({
                        id: `papabonus.baseCashbackText`,
                      })}
                    </div>
                    <div className={cx('PapaBonus__loyaltyButton')}>
                      <div className={cx('PapaBonus__lollipop')}>
                        <LollipopIconSmall width={29} height={29} />
                      </div>
                      {intl.formatMessage({ id: 'profile.cashback.label' }, { value: 10 })}
                    </div>
                  </div>
                </Accordion>
                <Accordion title={intl.formatMessage({ id: 'papabonus.question4' })}>
                  <div className={cx('PapaBonus__workContainer')}>
                    <div
                      style={{
                        marginBottom: '12px',
                      }}
                    >
                      <span className={cx('PapaBonus__greenText3')}>
                        {intl.formatMessage({ id: 'papabonus.10bonusow' })}
                      </span>
                      <span>{intl.formatMessage({ id: 'papabonus.question41' })}</span>
                    </div>

                    <div
                      style={{
                        marginBottom: '12px',
                      }}
                    >
                      <span className={cx('PapaBonus__greenText3')}>
                        {intl.formatMessage({ id: 'papabonus.20bonusow' })}
                      </span>
                      <span>{intl.formatMessage({ id: 'papabonus.question42' })}</span>
                    </div>

                    <div
                      style={{
                        marginBottom: '12px',
                      }}
                    >
                      <span className={cx('PapaBonus__greenText3')}>
                        {intl.formatMessage({ id: 'papabonus.40bonusow' })}
                      </span>
                      <span>{intl.formatMessage({ id: 'papabonus.question43' })}</span>
                    </div>

                    <div className={cx('PapaBonus__itemContainer')}>
                      {intl.formatMessage({ id: 'papabonus.question44' })}
                    </div>
                  </div>
                </Accordion>
                <Accordion title={intl.formatMessage({ id: 'papabonus.question3' })}>
                  <div className={cx('PapaBonus__workContainer')}>
                    <div className={cx('PapaBonus__itemContainer')}>
                      <Cash width={22} height={22} />
                      <div className={cx('PapaBonus__greenText3')}>
                        {intl.formatMessage({
                          id: `papabonus.paying`,
                        })}
                      </div>
                    </div>
                    <div className={cx('PapaBonus__itemContainer')}>
                      <Check width={22} height={22} />
                      <div className={cx('PapaBonus__greenText3')}>
                        {intl.formatMessage({
                          id: `papabonus.chaging`,
                        })}
                      </div>
                    </div>
                    <div className={cx('PapaBonus__programmContainer')}>
                      <div className={cx('PapaBonus__programmContainer_text')}>
                        {intl.formatMessage({
                          id: `papabonus.programmText3`,
                        })}
                        <Link to={getRoute('papabonus-rules')}>
                          {intl.formatMessage({
                            id: `papabonus.programmText4`,
                          })}
                        </Link>
                        {/*<div*/}
                        {/*  style={{*/}
                        {/*    color: '#50A684',*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  {intl.formatMessage({*/}
                        {/*    id: `papabonus.programmText4`,*/}
                        {/*  })}*/}
                        {/*</div>*/}
                      </div>
                    </div>
                  </div>
                </Accordion>
                <div className={cx('LoyaltyButton')}>
                  <Button onClick={showSignIn}>
                    {intl.formatMessage({ id: 'button.loginRegistration' })}
                  </Button>
                </div>
              </div>
            </div>
            <div className={cx('PapaBonus__right')}>
              <img src={papa_Bonus_img} alt="Papa_Bonus" />
              {/*<Composition width={672} height={789} />*/}
            </div>
          </div>
        </Container>
      </div>

      {isGiftsOpen && (
        <div className={cx('PapaBonus__gifts')}>
          <Container className={cx('PapaBonus__container')}>
            <Heading className={cx('PapaBonus__title_3')} level={3}>
              {intl.formatMessage({ id: 'papabonus.gifts.title' })}
            </Heading>
            <GiftsSlider withoutButton={!isAuthenticated} />
          </Container>
        </div>
      )}
    </div>
  );
}
